<script>
import api from "@services/api";
import MenuItem from "@components/MenuItem";
import appConfig from "@src/app.config";

export default {
  components: {
    MenuItem
  },
  props: {
    isMenuOpened: {
      type: Boolean,
      required: false,
      default: false,
      perfil: ""
    }
  },
  created() {
    this.getPerfil();
    this.handleMenu();
    window.addEventListener("resize", this.handleMenu);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleMenu);
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    ReportsComp: function() {
      return this.lodash
        .chain(this.reportList)
        .groupBy("workSpace")
        .map((value, key) => ({
          id: key,
          label: key,
          menuId: value[0].menuId,
          children: value.map(a => ({
            label: a.denominacao,
            KeyApi: a.keyApi,
            workSpaceApiKey: a.workSpaceApiKey,
            url: a.link,
            menuId: a.menuId,
            reportId: a.reportId
          }))
        }))
        .value();
    },
    tamanhoTela: function() {
      return window.innerWidth;
    }
    // corMenu(){
    //   console.log("🚀 ~ corMenu ~ this.user.clienteNome:", this.user.clienteNome)

    //   if (this.user && this.user.clienteNome) {
    //     if (this.user.clienteNome === "ASA") {
    //       return 'color: whitesmoke';
    //     }
    //   }
    //   return '';
    // }
  },
  mounted() {
    this.selectMenu();
    this.getReports();
    this.getMenu();
    // this.getPerfil();
  },
  data: function() {
    return {
      selected: 0,
      activeClass: "",
      empty: "",
      reportList: [],
      reportRoute: "/Report/",
      menuList: [],
      larguraAtual: 1200,
      menuMobile: false,
      appConfig: appConfig
    };
  },
  methods: {
    selectMenu() {
      this.selectMenu = 0;
      switch (this.$router.currentRoute.name) {
        case "Page 1":
          this.selected = 1;
          break;
      }
    },
    permiteAcesso(permission) {
      return this.user.Permissions.includes(permission);
    },
    getPerfil() {
      this.perfil = JSON.parse(localStorage.getItem("perfil"));
    },
    getReports() {
      api.get(`Report/Reports`).then(response => {
        this.reportList = response.data["data"];
      });
    },
    getMenu() {
      api.get(`Report/getMenu`).then(response => {
        this.menuList = response.data["data"];
      });
    },
    handleMenu() {
      this.larguraAtual = window.innerWidth;
      if (this.larguraAtual < 990) {
        this.menuMobile = true;
      } else {
        this.menuMobile = false;
      }
    }
  }
};
</script>

<template>
  <div>
    <b-collapse id="navigation" v-model="isMenuOpened">
      <ul class="navigation-menu mt-1" v-show="this.menuMobile == false">
        <li class="has-submenu" v-for="itemMenu in menuList" :key="itemMenu.id">
          <a href="#">
            <i :class="itemMenu.icon"></i> {{ itemMenu.denominacao }}
          </a>
          <MenuItem
            :menuItemList="ReportsComp.filter(x => x.menuId == itemMenu.id)"
          ></MenuItem>
        </li>
        <li class="has-submenu" v-if="appConfig.empresa != 'sisloc'">
          <a href="#"> <i class="ri-archive-drawer-line"></i> Cadastros </a>
          <ul class="submenu">
            <li>
              <a href="/dre"
                ><i class="ri-bar-chart-grouped-line"></i> DRE e DFC
              </a>
            </li>
            <li>
              <a href="/dePara"><i class="ri-file-copy-2-line"></i> De-Para</a>
            </li>
            <li>
              <a href="/DreRateio"><i class="ri-dashboard-line"></i> Rateios</a>
            </li>
          </ul>
        </li>
        <li class="has-submenu" v-if="this.user.perfil === 'Administrador'">
          <a href="#"> <i class="ri-user-settings-line"></i> Admin </a>
          <ul class="submenu">
            <li>
              <a href="/permissoes"
                ><i class="ri-shield-keyhole-line"></i> Acessos Relatórios</a
              >
            </li>
            <li>
              <a href="/grupo"><i class="ri-group-line"></i> Permissões</a>
            </li>
            <li>
              <a href="/Usuarios"><i class="ri-user-add-line"></i> Usuários</a>
            </li>
            <li>
              <a href="/workspace"><i class="ri-list-settings-line"></i> Editar Menu</a>
            </li>
          </ul>
        </li>
      </ul>

      <!-- End navigation menu -->
      <div class="clearfix"></div>
    </b-collapse>
    <!-- end navbar-custom -->
    <b-collapse id="navigation" v-model="isMenuOpened">
      <ul class="navigation-menu mt-1" v-show="this.menuMobile == true">
        <li v-for="itemReport in reportList" :key="itemReport.id">
          <a
            :href="
              '/Report/' + itemReport.keyApi + '/' + itemReport.workSpaceApiKey
            "
          >
            <i class="ri-folder-chart-line"></i> {{ itemReport.denominacao }}
          </a>
        </li>
      </ul>
    </b-collapse>
  </div>
</template>

<style scoped lang="scss">
body {
  background-image: none;
}

.submenu {
  li {
    display: flex;
    align-items: center;    

    a {
      display: flex;
      align-items: center; 

      i {
        margin-right: 5px;
      }
    }
  }
}
</style>
